export default __webpack_public_path__ + "static/media/backyard1.bcd3480e.jpeg";